
export default {
  name: 'manage-clock-logs',
  label: 'Clock Logs',
  path: 'clocklogs',
  link: 'clocklogs',
  props: true,
  icon: 'history',
  description: 'View and manage clock logs.',
  component: () => import('@/components/TabPanel.vue'),
  requirePerm: 'manage_clock_logs',
  breadcrumbLeaf: true,
  children: [
    {
      name: 'clock-log-list',
      label: 'List',
      title: 'Clock Logs',
      path: 'list/:view?',
      component: () => import('./ClockLogList.vue')
        .catch(error => {
          console.error('Failed to route to ClockLogList', error)
          throw error
        })
    },
    {
      name: 'manage-clock-logs-index',
      path: '',
      redirect: { name: 'clock-log-list' }
    }
  ]
}
